import { render, staticRenderFns } from "./hotTopic.vue?vue&type=template&id=b52bb662"
import script from "./hotTopic.vue?vue&type=script&lang=js"
export * from "./hotTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports